<template>
  <div class="treeCheck">
    <div
      v-for="(item,index) in tree"
      :key="index" 
      :class="item.wechatRecSubjectHidden ? 'wechatRecSubjectHidden':'' "
      >
    <div 
      class="tree-wary" 
      :class="level === 2 ? 'tree-wary-2':'tree-level-1'" 
    >
      <div class="tree-nodeName" @click.stop="handleNodeExpand(item)">
        <!-- 展开收起按钮 -->
        <i class="parent-class"  v-if="item.nodeType==2"></i> 
        <!-- 分类 -->
        <i class="node-type-class" v-if="item.nodeType==2"></i> 
        <!-- 专题 -->
        <i class="node-type-zt"  v-if="item.nodeType==1"></i> 
        <p>{{ item.nodeName }}</p>
      </div>
      <div class="tree-checkbox">
        <!-- 判断是否有children -->   
        <Checkbox
          v-model="item.checked"  
          shape="square" 
          @click.stop="()=>{click(item)}"
          :disabled="item.wechatRecSubjectHidden ? true:false"
        > 
        </Checkbox>
      </div> 
    </div>
     <div v-if="defaultExpandedKeys.indexOf(item.nodeId) > -1">
       <!-- 把tree数据的子集给tree ，再循环自己，这一步就是递归调用自己--> 
      <SubjectTree 
        :level="level+1"   
        v-if="item.children" 
        :tree="item.children"
        @check="click"
      ></SubjectTree>
     </div>
    </div>
  </div> 
</template>

<script>
import SubjectTree from '@/components/subjectTree/subjectTree'
import { Checkbox } from 'vant';
export default {
    name: 'SubjectTree',      //组件名称
    components: { Checkbox,SubjectTree },    //引入了vant的checkbox组件
    // 父组件传入子组件数据
    props: {
      tree: {
        type: Array,
        default: () => [],  
      },
      level:{
        type:Number,
        default:1
      },
      defaultExpandedKeys: {
        type:Array,
        default:()=>[]
      },
      defaultCheckedKeys: {
        type:Array,
        default:()=>[]
      },
      treeName:{
        type:String,
        default:""
      }
    },
    methods: {
      // ...mapMutations(['saveCheckItem']),
      //父节点的checked状态，传递给子节点（全选反选）
      click(item) {     
        if(item.wechatRecSubjectHidden) return false
        this.$emit('check',item,this.treeName)
      },   
      handleNodeExpand(item){
        (item.children && item.children.length > 0) && this.$emit('node-expand',item)
      }, 
    },
    data() {
      return {
      };
    },
    watch: { 
      
    }, 
}

</script>

<style>
@import url("./subjectTree.css");
</style>